//import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid2";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard React example components
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";

import GraficoProcesosEstado from "pages/inicio/components/graficoProcesosEstado.js";
import GraficoProcesosFinalidad from "pages/inicio/components/graficoProcesosFinalidad";
import GraficoProcesosEtapa from "pages/inicio/components/graficoProcesosEtapa";
import CardCartera from "pages/inicio/components/cardCartera";
import CardAsesor from "pages/inicio/components/cardAsesor";
import CardOperador from "pages/inicio/components/cardOperador";
import DotSpinner from "common/Loader/Loader";

import useUserRoles from "hooks/useUserRoles";

function Inicio() {
  const { user, roles } = useUserRoles();
  //alert(JSON.stringify(user));
  if (!user) return <DotSpinner />;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {(roles.isAdmin ||
        roles.isInvitado ||
        roles.isAsesorExterno ||
        roles.isAsesorInterno ||
        roles.isAsistente ||
        roles.isOperador ||
        roles.isCartera ||
        roles.isCoordinador ||
        roles.isDirector) && (
        <SuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <strong>{user.nombre_completo}</strong>, de acuerdo a tus Roles te presentamos la
              siguiente información:
            </Grid>
          </Grid>
        </SuiBox>
      )}
      {(roles.isAdmin || roles.isCoordinador || roles.isDirector) && (
        <SuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid size={4}>
              <GraficoProcesosEtapa />
            </Grid>
            <Grid size={4}>
              <GraficoProcesosEstado />
            </Grid>
            <Grid size={4}>
              <GraficoProcesosFinalidad />
            </Grid>
          </Grid>
        </SuiBox>
      )}
      {(roles.isAdmin || roles.isCartera) && (
        <SuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <CardCartera />
            </Grid>
          </Grid>
        </SuiBox>
      )}
      {(roles.isAdmin || roles.isAsesorExterno || roles.isAsesorInterno) && (
        <SuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <CardAsesor />
            </Grid>
          </Grid>
        </SuiBox>
      )}
      {(roles.isAdmin || roles.isAsistente || roles.isOperador) && (
        <SuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <CardOperador />
            </Grid>
          </Grid>
        </SuiBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Inicio;
